  <template>
  <div>
   <b-modal style="padding:15px" no-stacking size="lg" id="StockTakeVerificationModal" ref="modal" title="Stock Take" ok-title="Verify Stock" cancel-title="Close" 
      @hidden= "resetModal()" @ok= "handleOk" @show= "updateModel()" :ok-disabled = "this.$refs.FlourTypesPhysicalCountForm != undefined ? !this.$refs.FlourTypesPhysicalCountForm.checkValidity() : true">
        <form ref="FlourTypesPhysicalCountForm" @submit.stop.prevent= "handleSubmit">
          <div class="row" v-for="rec in flourTypesCounts" :key=rec.flourTypeWeightLinkId>
           <div class="col-md-4">
               <b-form-group  label="Flour Type(Bag Type)" label-for="flourType" autocomplete="off">
                <b-form-input :id="'flourType' + rec.flourTypeWeightLinkId" v-model= "rec.flourNameWithWeight" readonly required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
               <b-form-group  label="Physical Count" label-for="count" autocomplete="off">
                <b-form-input :id="'count'+rec.flourTypeWeightLinkId" v-model= "rec.physicalCount" placeholder="Enter Physical Count"  required></b-form-input>
              </b-form-group>
            </div>
             <div class="col-md-4">
              <b-form-group  label="Description" label-for="description" autocomplete="off">
                  <b-form-input :id="'description' + rec.flourTypeWeightLinkId" v-model= "rec.description" placeholder="Enter Discription"></b-form-input>
              </b-form-group>
             </div>
              <!-- <div style="display:none">
              <b-form-group  label="RecordId" label-for="recordId" autocomplete="off">
                  <b-form-input id="recordId" v-model= "rec.flourTypeWeightLinkId"  required></b-form-input>
              </b-form-group>
            </div> -->
          </div>   
          <div class="text-center">
            <b-spinner v-if="isLoading" label="Loading..."></b-spinner>  
          </div>
        </form>
      </b-modal>

       <b-modal style="padding:15px" size="lg" id="AddAdjustmentEntryModal2" ref="modal" title="Pending Stock Verification" ok-title="Verify Stock" cancel-title="Close" 
      @hidden= "resetModal2()" @ok= "handleOk2" @show= "updateModel2()" :ok-disabled = "this.$refs.FlourTypesCountDifferenceform != undefined ? !this.$refs.FlourTypesCountDifferenceform.checkValidity() : true">
        <form ref="FlourTypesCountDifferenceform" @submit.stop.prevent= "handlesubmit2">
          <div style="margin-top:-15px;margin-bottom:15px" class ="row">
            <div class="col-md-9"></div>
            <div style="text-align:end" class ="col-md-3">
              <button type = "button" style="color:white;background-color:rgb(112 113 113);border-radius:3px;padding:5px" @click ="cancelStockTake()">Cancel Stock Take</button>
            </div>
          </div>
          <div class="row" v-for="rec in flourTypesDifferences" :key=rec.flourTypeWeightLinkId>
           <div class="col-md-3">
               <b-form-group  label="Flour Type(Bag Type)" label-for="flourType" autocomplete="off">
                <b-form-input :id="'flourType2' + rec.flourTypeWeightLinkId" v-model= "rec.flourNameWithWeight" readonly></b-form-input>
              </b-form-group>
            </div>
             <div class="col-md-2">
              <b-form-group  label="Difference" label-for="differ" autocomplete="off">
                  <b-form-input :id="'diff2' + rec.flourTypeWeightLinkId" v-model= "rec.difference" readonly></b-form-input>
              </b-form-group>
             </div>
             
            <div class="col-md-2">
               <b-form-group  label="Physical Count" label-for="count" autocomplete="off">
                <b-form-input :id="'count2'+rec.flourTypeWeightLinkId" v-model= "rec.physicalCount" type="number" placeholder="Enter Physical Count" readonly></b-form-input>
              </b-form-group>
            </div>
             <div class="col-md-2">
              <b-form-group  label="Description" label-for="description" autocomplete="off">
                  <b-form-input :id="'description2' + rec.flourTypeWeightLinkId" v-model= "rec.description" placeholder="Enter Discription" readonly></b-form-input>
              </b-form-group>
             </div>
              <div class="col-md-2">
                <b-form-group  label="Status" label-for="status" autocomplete="off">
                   <b-form-checkbox
                   :id="'isEntryDone' + rec.flourTypeWeightLinkId" 
                    v-model="rec.isEntryDone"
                    name="checkbox-1"
                    value: = true
                    unchecked-value: = false
                    disabled
                    >
                    Accounted
                  </b-form-checkbox>
                 
                </b-form-group>
             </div>
              <div class="col-md-1">
                <b-form-group v-if="!rec.isVerified" label="Actions" label-for="Action" autocomplete="off">

                    <span :title ="rec.difference > 0 ? 'Add Normal Shipment':'Add Normal Production'" @click= "addNormalEntry(rec)">
                      <i role="button" style="color:green" class="far fa-edit"></i>&nbsp;|&nbsp;
                    </span>
                    <span  :title ="rec.difference > 0 ? 'Add Adjustment Shipment':'Add Adjustment Production'" @click= "addAdjustmentEntry(rec)">
                      <i role="button"  style="color:#5bb8cd" class="far fa-edit"></i>
                    </span>

                </b-form-group>
             </div>
           
              <!-- <div style="display:none">
              <b-form-group  label="RecordId" label-for="recordId" autocomplete="off">
                  <b-form-input id="recordId" v-model= "rec.flourTypeWeightLinkId"  required></b-form-input>
              </b-form-group>
            </div> -->
          </div>   
          <div class="text-center">
            <b-spinner v-if="isLoading" label="Loading..."></b-spinner>  
          </div>
        </form>
      </b-modal>
      <Toaster ref= "toaster"/>
      <AddStockTakeProductionModal v-if= "FlourObject!=null" :flourObject = "FlourObject" :isAdjustment = "IsAdjustmentEntry"/>
      <AddStockTakeShipmentOtherModal v-if= "FlourObject!=null" :flourObject = "FlourObject" :isAdjustment = "IsAdjustmentEntry"/>
       <AddStockTakeShipmentGovtModal v-if= "FlourObject!=null" :flourObject = "FlourObject" :isAdjustment = "IsAdjustmentEntry"/>
      </div>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster';
import AddStockTakeShipmentOtherModal from '../../stock-take/modals/AddStockTakeShipmentOtherModal';
import AddStockTakeShipmentGovtModal from '../../stock-take/modals/AddStockTakeShipmentGovtModal';
import AddStockTakeProductionModal from '../../stock-take/modals/AddStockTakeProductionModal';
export default {
    name: 'AddStockTake',
    data(){
        return{
          moduleName:'StockTake',   
          isLoading:false,
          CompanyId:null,
          flourTypesCounts: [],
          // accountedArray:[],

          //adjustment entries modals data
          FlourObject:null,
          IsAdjustmentEntry:false,
          //modal 2 data
          flourTypesDifferences:[] 
		}
  },
  components:{
    Toaster,
    AddStockTakeShipmentGovtModal,
   AddStockTakeShipmentOtherModal,
   AddStockTakeProductionModal
  },



methods:{
 
  getTempStockTakeFlourDetails(rec)
  {
    axios.get("/StockTake/gettempstocktake/"+ rec.id)
      .then(res=>{
            if(res.data.status == 1)
            {
              this.FlourObject = res.data.data;
              this.OpenRelatedModal(rec.difference);      
            }
            else if(res.data.status == -1)
            {
                this.$refs.toaster.showToast("Error",'danger',"Pending stock verification record not found");
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
  },
cancelStockTake()
{
  let Id = this.$auth.user().companyId;
  console.log("/StockTake/CancelStockTake/"+Id)
  axios.get("/StockTake/CancelStockTake/"+Id)
      .then(res=>{
            if(res.data.status == 1)
            {
             this.$bvModal.hide('AddAdjustmentEntryModal2')
              this.$refs.toaster.showToast("Success",'success',"Stock take has been cancelled successfully");
            }
            else if(res.data.status == -1)
            {
                this.$refs.toaster.showToast("Error",'danger',"Unable to cancel the stock take");
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
},
MarkEntryAsDone(id)
{
   let index = this.flourTypesDifferences.findIndex(x=>x.flourTypeWeightLinkId == id);
  //  accountedArray.push(index)
  //  console.log(id);
  //  console.log(index);
   if(index > -1)
   {
      this.flourTypesDifferences[index].isEntryDone = true;
      // this.accountedArray.push(index)
   }
  
},

// MarkEntriesArray()
// { 
//     this.flourTypesDifferences.forEach(index=>{
//     this.flourTypesDifferences[index].isEntryDone = true;

//   });
// },
OpenRelatedModal(diff)
{
  if(diff>0)
   {
     if(this.FlourObject.flourBaseType == 2)
     {
        setTimeout(
            () => {
         this.$bvModal.show("AddStockTakeShipmentOtherModal")
        },100)
        
     }
     else if(this.FlourObject.flourBaseType == 1)
     {
        setTimeout(
            () => {
       this.$bvModal.show("AddStockTakeShipmentGovtModal")
        },100)
        
     }
   }
   else
   {
      setTimeout(
            () => {  
      this.$bvModal.show("AddProductionModal")
        },100)
    
   }
},
 addNormalEntry(rec)
 {
   console.log(rec)
   this.IsAdjustmentEntry = false;
   this.getTempStockTakeFlourDetails(rec);
 },

addAdjustmentEntry(rec)
 {
   this.IsAdjustmentEntry = true;
   this.getTempStockTakeFlourDetails(rec);
 },
 
  addStockTake()
  {
    
      this.addStockTakeEntries();
    
  },
  
   chkPendingStockTake()
  {
    
      let compId = this.$auth.user().companyId
      console.log(compId)
    axios.get("/StockTake/IsPendingStockTake/"+compId)
      .then(res=>{
            if(res.data.status == 1)
            {
              console.log("pecndi")
              this.getPendingStockTake();
              this.$bvModal.show('AddAdjustmentEntryModal2')
              this.$bvModal.hide('StockTakeVerificationModal')  
            }
            else if(res.data.status == -1)
            {
                console.log("")
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
  },
  addStockTakeEntries()
  {
    
      // console.log(this.flourTypesCounts)
    axios.post('/StockTake/Add',
      {"CompanyId":this.$auth.user().companyId,"StockTakeEntries":this.flourTypesCounts})
      .then(res=>{
            if(res.data.status == 1)
            {
              if(res.data.data.isAllVerified)
              {
                this.$refs.toaster.showToast('Sucess','success',"Stock Take has been performed successfully!");
                 this.$bvModal.hide('StockTakeVerificationModal');
                  this.$parent.getAllAdjustmentEntries();  
              }
              else
              {
                  this.getPendingStockTake();
                  this.$refs.toaster.showToast('Sucess','warning',res.data.msg);
              // console.log(this.flourTypesCounts)   
                  this.$bvModal.show('AddAdjustmentEntryModal2')
              }
                  
            }
            else if(res.data.status == -1)
            {
                this.$refs.toaster.showToast('Error','error',res.data.msg)
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
  },
  getPendingStockTake()
  {
   // console.log(this.flourTypesCounts)
    axios.post('/StockTake/getPending/'+this.$auth.user().companyId)
      .then(res=>{
            if(res.data.status == 1)
            {
              console.log(res)
              this.flourTypesDifferences = res.data.data;
              // // console.log(this.flourTypesCounts)
              //    this.$refs.toaster.showToast('Sucess','success',res.data.msg);
              //     this.$bvModal.hide('StockTakeVerificationModal')
              //     this.$bvModal.show('AddAdjustmentEntryModal2')
            }
            else if(res.data.status == -1)
            {
                this.$refs.toaster.showToast('Error','error',res.data.msg)
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
  },
   getFlourTypesForStockTake(){ 
        this.isLoading = true;
     axios.post('/flourweighttypelink/getforstocktake',
      {"CompanyId":this.$auth.user().companyId})
      .then(res=>{
            this.isLoading = false;
            if(res.data.status == 1)
            {
              this.flourTypesCounts = res.data.data;
              //  console.log(this.flourTypesCounts)
                //  this.$refs.toaster.showToast('Sucess','success','Flour Type has been added successfully!')
                //   this.$bvModal.hide('StockTakeVerificationModal')
                //   this.$parent.getflourTypesCounts();  
            }
            else if(res.data.status == -1)
            {
                this.$refs.toaster.showToast('Error','error',res.data.msg)
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.FlourTypesPhysicalCountForm.checkValidity()
        // this.usernameState = valid
        return valid;
      },

     checkNonNumber()
     {
       let chk = false;
       this.flourTypesCounts.forEach(element => {
         if(isNaN(element.physicalCount))
         {
          //  console.log(element.physicalCount)
           chk = true;
         }
         else{
           if(element.physicalCount < 0)
           {
             chk = true;
           }
          // console.log(element.physicalCount)
         }
       });
       return chk;
     },

      resetModal() {
     
      },
      
      updateModel()
      {
        // this.accountedArray = [];
        this.getFlourTypesForStockTake();
        this.chkPendingStockTake();
      },
      handleOk(bvModalEvt) {
         console.log("handl1")
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return;
        } 
        if(this.checkNonNumber())
        {
          // console.log("in checknow")
          this.$refs.toaster.showToast('Error','danger','Please fill up all the physical counts with numbers > 0')
          return;
        }
        this.addStockTake()
       
      },
//add redirect when alread stocktake exist ..........................................................
//2nd modal methods
      resetModal2()
      {

      }, 
      updateModel2()
      {

      },
      checkFormValidity2()
      {
        const valid = this.$refs.FlourTypesCountDifferenceform.checkValidity();
        return valid;
      },
     
      handleOk2(bvModalEvt) {
        console.log("handl2")
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit2()
    },
      handleSubmit2() {
         console.log("handlsub2")
        // Exit when the form isn't valid
        if (!this.checkFormValidity2()) {
          return;
        } 
       this.verfiyStock()
       
      },

      verfiyStock()
      {
        axios.post('/StockTake/verify',{"StockTakeEntries":this.flourTypesDifferences,"CompanyId":this.$auth.user().companyId})
      .then(res=>{
            if(res.data.status == 1)
            {
             
                 this.$refs.toaster.showToast('Sucess','success','Stock Take has been performed successfully!')
                 this.$bvModal.hide('AddAdjustmentEntryModal2')
                  this.$parent.getAllAdjustmentEntries();  
                //   this.$parent.getFlourTypes();  
            }
            else if(res.data.status == -1)
            {
                this.$refs.toaster.showToast('Error','warning',res.data.msg)
                this.getPendingStockTake();
                // this.MarkEntriesArray();
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
      }

  }
	

}
</script>
